import { CheckCircle2 } from "lucide-react";
import { Reveal, SectionHeading } from "../Reveal";
import { FlagPair } from "../Brand";
import { useContent } from "../../context/ContentContext";

export const About = () => {
  const { about } = useContent();
  return (
    <section id="about" className="bg-white py-24" data-testid="about-section">
      <div className="mx-auto grid max-w-7xl items-center gap-14 px-4 sm:px-6 lg:grid-cols-2 lg:px-8">
        <Reveal className="relative">
          <div className="overflow-hidden rounded-2xl shadow-xl shadow-navy/10">
            <img
              src="https://images.unsplash.com/photo-1670121180530-cfcba4438038"
              alt="Cargo ship at dock"
              className="h-[440px] w-full object-cover"
            />
          </div>
          <div className="absolute -bottom-6 -right-2 rounded-2xl border border-gray-100 bg-white p-5 shadow-xl sm:-right-6">
            <FlagPair className="text-navy" />
            <p className="mt-2 font-display text-2xl font-black text-navy">USA → Ghana</p>
            <p className="text-xs uppercase tracking-widest text-gold-700">Trusted Logistics Partner</p>
          </div>
        </Reveal>

        <Reveal delay={0.15}>
          <SectionHeading eyebrow={about.eyebrow} title={about.title} />
          {about.paragraphs.map((p, i) => (
            <p key={i} className="mt-4 text-base leading-relaxed text-muted-foreground first:mt-5">{p}</p>
          ))}

          <ul className="mt-7 grid gap-3 sm:grid-cols-2">
            {about.points.map((p) => (
              <li key={p} className="flex items-start gap-3 text-sm font-medium text-navy">
                <CheckCircle2 className="mt-0.5 h-5 w-5 shrink-0 text-gold" /> {p}
              </li>
            ))}
          </ul>
        </Reveal>
      </div>
    </section>
  );
};
